import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React, { useCallback, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import { LoadableComponentContext } from '@wix/da-hooks/pkg/useLoadableComponent';
import { useAction } from '@wix/da-hooks/pkg/useAction';
import { CommentEditorContext } from '../../../CommentEditor/context';
import { CommentEditorSource } from '../../../CommentEditor/redux/types';
import { focusEditor } from '../../../CommentEditor/redux/actionCreators';
import s from './LazyPlaceholder.scss';
/**
 * What we'll show instead of the editor if the DaEditor chunk isn't loaded yet.
 *
 * It's a button that'll trigger the chunk to load.
 */ const LazyPlaceholder = ()=>{
    const { t } = useTranslation();
    const { editorSource, editorId } = useContext(CommentEditorContext);
    const dispatchFocusEditor = useAction(focusEditor);
    const _useContext = useContext(LoadableComponentContext), { triggerProps: { onClick } } = _useContext, restTriggerProps = _object_without_properties(_useContext.triggerProps, [
        "onClick"
    ]);
    const handleClick = useCallback(()=>{
        onClick();
        dispatchFocusEditor(editorId);
    }, [
        onClick,
        dispatchFocusEditor,
        editorId
    ]);
    return /*#__PURE__*/ React.createElement(PlainButtonOrLink, _object_spread({
        className: s['root'],
        onClick: handleClick
    }, restTriggerProps), editorSource === CommentEditorSource.Reply ? t('commentbox.editor.placeholder.reply') : t('commentbox.editor.placeholder'));
};
LazyPlaceholder.displayName = 'LazyPlaceholder';
export default LazyPlaceholder;

//# sourceMappingURL=LazyPlaceholder.js.map